import Vue from "vue";
import Router from "vue-router";
//import Home from "@/components/home";
const Home = () => import("@/components/home");

const Loader = () => import("@/components/loader/loader");
//const Home = resolve => require(["@/components/home"], resolve);

//import Login from "@/components/login";
const Login = () => import("@/components/login");

//import Members from "@/components/Members/members";
const Members = () => import("@/components/Members/members");

//import Locations from "@/components/Locations/locations";
const Locations = () => import("@/components/Locations/locations");

//import Company from "@/components/Company/company";
const Company = () => import("@/components/Company/company");

//import Kiosk from "@/components/Kiosk/kiosk";
const Kiosk = () => import("@/components/Kiosk/kiosk");

//import Shifts from "@/components/Shifts/shifts";
const Shifts = () => import("@/components/Shifts/shifts");

//import Weeklyoff from "@/components/Weeklyoff/weeklyoff";
const Weeklyoff = () => import("@/components/Weeklyoff/weeklyoff");

//import Holiday from "@/components/Holiday/holiday";
const Holiday = () => import("@/components/Holiday/holiday");

//import LeaveType from "@/components/Leave/leave";
//import Balance from "@/components/Leave/balance";
//import LeaveSettings from "@/components/Leave/leaveSettings";
//import Forms from "@/components/Forms/forms";
const Forms = () => import("@/components/Forms/forms");

//import FormResponse from "@/components/Forms/formResponse";
const FormResponse = () => import("@/components/Forms/formResponse");

//import Reports from "@/components/Reports/reports";
//import Builder from "@/components/Reports/builder";
const Builder = () => import("@/components/Reports/builder");

//import Timesheet from "@/components/Timesheet/timesheet";
const Timesheet = () => import("@/components/Timesheet/timesheet");

//import TimesheetEdit from "@/components/Timesheet/timesheetEdit";
const TimesheetEdit = () => import("@/components/Timesheet/timesheetEdit");

//import FieldTrackingReports from "@/components/Field Tracking/fieldtrackingreports";
const FieldTrackingReports = () => import("@/components/Field Tracking/fieldtrackingreports");

//import Help from "@/views/help";
const Help = () => import("@/views/help");

//import Profile from "@/components/Profile/Profile";
const Profile = () => import("@/components/Profile/Profile");

//import Tags from "@/components/Tags/tags.vue";
const Tags = () => import("@/components/Tags/tags.vue");

//import Groups from "@/components/Groups/groups.vue";
const Groups = () => import("@/components/Groups/groups.vue");

import store from "@/store";
//const store = () => import("@/store");

//import Timeline from "@/components/Reports/timeline";
//import FirstTimeSetup from "@/components/FirstTimeSetup/firstTimeSetup";
const FirstTimeSetup = () => import("@/components/FirstTimeSetup/firstTimeSetup");

//import Privacy from "@/components/privacy/privacy";
const Privacy = () => import("@/components/privacy/privacy");

//import Terms from "@/components/privacy/terms";
const Terms = () => import("@/components/privacy/terms");

//import TimelineV2 from "@/components/Timeline/timeline";
import ResetPassword from "@/components/reset-password";
//const ResetPassword = () => import("@/components/reset-password");

//import confirmEmail from "@/views/confirmEmail";
const confirmEmail = () => import("@/views/confirmEmail");

//import Tasks from "@/views/tasks";
//import NotificationList from "@/components/toolbar/notificationlist";
const NotificationList = () => import("@/components/toolbar/notificationlist");

import canSee from "@/utilities/canSee";

//import addForm from "@/components/Forms/addForm";
const addForm = () => import("@/components/Forms/addForm");

//import bulkimport from "@/components/Members/bulkImport";
const bulkimport = () => import("@/components/Members/bulkImport");

//import bulklocation from "@/components/Locations/bulkLocation";
const bulklocation = () => import("@/components/Locations/bulkLocation");

//import bulkholiday from "@/components/Holiday/bulkHoliday";
const bulkholiday = () => import("@/components/Holiday/bulkHoliday");

//import bulkattendance from "@/components/Timesheet/bulkAttendance";
const bulkattendance = () => import("@/components/Timesheet/bulkAttendance");

//import subscription from "@/components/Subscription/subscription";
const subscription = () => import("@/components/Subscription/subscription");

import error from "@/components/Unavailable/error";
//import expenses from "@/components/expense/expenses.vue";
//import dummy from "@/components/Timesheet/timesheet_dummy.vue";
import fb from "@/utilities/firebase";

Vue.use(Router);

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? "hash" : "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/load",
      name: "Load",
      component: Loader,
      meta: {
        requiresAuth: false
      }
    },

    {
      path: "/firstTimeSetup",
      name: "Setup",
      component: FirstTimeSetup,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    /* {
      path: "/timeline",
      name: "Timeline",
      component: Timeline,
      meta: {
        requiresAuth: false
      }
    },
     {
      path: "/dummy",
      name: "Timesheet Dummy",
      component: dummy,
      meta: {
        requiresAuth: false
      }
    },*/
    /*  {
      path: "/timelineV2",
      name: "TimelineV2",
      component: TimelineV2,
      meta: {
        requiresAuth: false
      }
    },*/
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPassword,
      meta: {
        requiresGuest: true,
        requiresAuth: false
      }
    },

    {
      path: "/verify-email",
      name: "confirmEmail",
      component: confirmEmail,
      meta: {
        requiresGuest: true,
        requiresAuth: false
      }
    },
    {
      path: "/members",
      name: "Members",
      component: Members,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bulkimport",
      name: "Batch members",
      component: bulkimport,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/bulklocation",
      name: "Batch locations",
      component: bulklocation,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/bulkholiday",
      name: "Batch holidays",
      component: bulkholiday,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/bulkattendance",
      name: "Batch attendances",
      component: bulkattendance,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/subscription",
      name: "Subscription",
      component: subscription,
      meta: {
        subPage: false,
        requiresAuth: true
      }
    },
    {
      path: "/kiosk",
      name: "Kiosk",
      component: Kiosk,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tags",
      name: "Tags & Groups",
      component: Tags,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/privacy",
      name: "Privacy Policy",
      component: Privacy,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/terms",
      name: "Terms of Service",
      component: Terms,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/groups",
      name: "Groups",
      component: Groups,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shifts",
      name: "Shifts",
      component: Shifts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/weeklyoff",
      name: "Weeklyoff",
      component: Weeklyoff,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/holiday",
      name: "Holiday",
      component: Holiday,
      meta: {
        requiresAuth: true
      }
    },
    /*  {
      path: "/leaveType",
      name: "Leave Type",
      component: LeaveType,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/balance",
      name: "Balance",
      component: Balance,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/leaveSettings",
      name: "Leave Settings",
      component: LeaveSettings,
      meta: {
        requiresAuth: true
      }
    },*/
    {
      path: "/forms",
      name: "Forms",
      component: Forms,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/locations",
      name: "Locations",
      component: Locations,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/error",
      name: "Error",
      component: error,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/reports",
      name: "Reports",
      component: Builder,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/builder',
    //   name: 'Reports Builder',
    //   component: Builder,
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: "/company",
      name: "Company",
      component: Company,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/timesheet",
      name: "Timesheet",
      component: Timesheet,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/fieldtrackingreports",
      name: "Field Tracking Reports",
      component: FieldTrackingReports,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/help",
      name: "Help",
      component: Help,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    /*  {
      path: "/tasks",
      name: "Tasks",
      component: Tasks,
      props: true,
      meta: {
        requiresAuth: true
      }
    },*/
    {
      path: "/formResponse",
      name: "Responses",
      component: FormResponse,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/notificationslist",
      name: "Notifications",
      component: NotificationList,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },

    {
      path: "/timesheetEdit/:attendanceId",
      name: "Timesheet Edit",
      component: TimesheetEdit,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },

    {
      path: "/addForm",
      name: "Form",
      component: addForm,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    },
    {
      path: "/addForm/:updateFormId",
      name: "Edit",
      component: addForm,
      props: true,
      meta: {
        subPage: true,
        requiresAuth: true
      }
    }
    /* {
      path: "/expenses",
      name: "expenses",
      component: expenses,
      meta: {
        requiresAuth: false
      }
    }*/
  ]
});

router.beforeEach((to, from, next) => {
  //Updating page in analytics
  try {
    fb.screen(to.name);
  } catch (e) {
    console.log(e);
  }

  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (!store.getters.user && (to.name != "ResetPassword" || to.name != "confirmEmail")) {
      // Go to login
      next({
        path: "/login"
      });
    } else if (to.name == "ResetPassword" || to.name == "confirmEmail") {
      next();
    } else {
      // Proceed to route
      if (store.getters.firstTimeSetup) {
        if (
          canSee(
            this,
            "pageView",
            store.getters.userDetails.role,
            {
              page: to.name
            },
            store.getters.userDetails.permissions
          )
        ) {
          /*  if(store.getters.kioskMode){

            next({
              path: '/kiosk',
              query: {
                redirect: to.fullPath,
              },
              replace: true,
            });

          }else{

            next();

          }  */

          next();
        } else {
          next({
            path: "/error",
            query: {
              redirect: to.fullPath,
              errorType: "authError"
            },
            replace: true
          });
        }
      } else if (to.name != "Setup") {
        next({
          path: "/firstTimeSetup",
          query: {
            redirect: to.fullPath
          },
          replace: true
        });
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // this code is exicuted for auto sign in method (IN CASE OF USEr IS LOGED IN and Toke is valid token)

    next();

    /*
    if (store.getters.user) {
      // Go to login
      next({
        path: '/',
      });
    } else {
      // Proceed to route
      // console.log("proceed to route")
      next();
    } */
  } else {
    // Proceed to route

    // If firstTime setup not done, redirect to first time setup
    next();
  }
});

export default router;
